import { useEffect, useRef, useState } from "react";
import { FormState, Step } from "../types";
import {
  ALL_DIGITAL_VALUE,
  DIGITAL_TYPE
} from "../utils/ValidationUtil";

export function useActivityFormState(submissionPage: number) {
  const INITIAL_ACTIVITY: Partial<FormState> = {
    name: "",
    description: "",
    municipalities: [],
    ages: [],
    types: [],
    submissionPage,
    tryout: "",
    far: "",
    place: "",
    address: "",
    hasNoFixedAddress: false,
    addresses: [],
    onlineOrNoSpecificAddress: false,
    startAcceptCriteria: false,
    certificationStatus: undefined,
  };

  const INITIAL_STATE: FormState = {
    ...INITIAL_ACTIVITY,
    email: "",
    contactEmail: "",
  } as FormState;

  const [data, setData] = useState<FormState>(INITIAL_STATE);
  const [step, setStep] = useState<Step>(1);
  const [submitted, setSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errors, setErrors] = useState<Set<string>>(new Set());

  const stepRef = useRef<HTMLDivElement>(null);
  const thankYouRef = useRef<HTMLDivElement>(null);
  const errorAlertRef = useRef<HTMLDivElement>(null);

  // ── Fokus vid stegbyte eller tack-sida
  useEffect(() => {
    if (submitted) {
      thankYouRef.current?.focus();
    } else {
      stepRef.current?.focus();
      setErrors(new Set());
    }
  }, [step, submitted]);

  // ── Auto-välj digital kommun
  useEffect(() => {
    if (
      data.types.includes(DIGITAL_TYPE) &&
      !data.municipalities.includes(ALL_DIGITAL_VALUE)
    ) {
      setData((s) => ({ ...s, municipalities: [ALL_DIGITAL_VALUE] }));
    }
  }, [data.types]);

  return {
    data,
    setData,
    step,
    setStep,
    submitted,
    setSubmitted,
    isSubmitting,
    setIsSubmitting,
    errors,
    setErrors,
    stepRef,
    thankYouRef,
    errorAlertRef,
    INITIAL_ACTIVITY,
  };
}
